import { Box, Stack } from '@mui/material'
import { styled } from '@mui/material/styles'
import React from 'react'
import { useLayoutContext } from '../../context/LayoutProvider/LayoutProvider'
import DetailsLoading from '../Loading/DetailsLoading'
import DealsKanbanHeader from './DealsKanbanHeader'
import KanbanColumn from './KanBanColumn'
import { StickyHeader } from './style'
import './styles.css'

const Root = styled('div')({
  display: 'flex',
  flexWrap: 'nowrap',
  overflowX: 'auto',
  height: 'calc(100vh - 182px)',
  width: '100vw',
  padding: '16px',
})

const DealsKanban = ({
  kanbanData,
  stageTotals,
  extraStages,
  setExtraStages,
  totalDeals,
  activePipeline,
  weightedPipeline,
  dealWonRevenue,
  isLoading,
}) => {
  const { pinned } = useLayoutContext()
  const MemoizedKanbanColumn = React.memo(KanbanColumn)

  return (
    <>
      {isLoading ? (
        <DetailsLoading />
      ) : (
        <Stack className="deals-kanban-container" sx={{ height: pinned ? 'calc(100vh - 60px)' : '100vh' }}>
          <StickyHeader>
            <DealsKanbanHeader
              extraStages={extraStages}
              setExtraStages={setExtraStages}
              totalDeals={totalDeals}
              activePipeline={activePipeline}
              weightedPipeline={weightedPipeline}
              dealWonRevenue={dealWonRevenue}
              isLoading={isLoading}
            />
          </StickyHeader>
          <Box
            sx={{
              flex: 1,
              display: 'flex',
            }}
          >
            <Root>
              {Object.keys(kanbanData).map(key => (
                <MemoizedKanbanColumn
                  key={key}
                  columnId={key}
                  items={kanbanData[key].items}
                  label={kanbanData[key].label}
                  total={stageTotals[key]?.total}
                  grossProfit={stageTotals[key]?.grossProfit}
                />
              ))}
            </Root>
          </Box>
        </Stack>
      )}
    </>
  )
}

export default DealsKanban
